/**
 * Region tables for the Season summary modal.
 * Pure JS for `node --test`.
 */

/**
 * Destination-specific region table only (where the fruit in that dest came from).
 * World-region share is not shown in the modal.
 */
export function pickRegionTables(preview) {
  const tables = [];
  const dest = String(preview?.destination ?? '').toUpperCase();
  const destRows = preview?.region_dest;
  if (dest !== 'ALL' && Array.isArray(destRows) && destRows.length > 0) {
    tables.push({ kind: 'dest', dest: preview.destination, rows: destRows });
  }
  return tables;
}
